export const natures: NatureSetup[] = [
    // Colonies
    { type: 'antColony', size: 2, x: 24, y: 24 },
    { type: 'dangerColony', size: 2, x: 8, y: 42 },

    // Objects
    { type: 'leaf1', x: 20, y: 36 },
    { type: 'leaf1', x: 24, y: 43 },
    { type: 'leaf1', x: 31, y: 22 },
    { type: 'leaf1', x: 34, y: 32 },
    { type: 'leaf1', x: 37, y: 16 },
    { type: 'leaf1', x: 38, y: 32 },
    { type: 'leaf1', x: 40, y: 16 },
    { type: 'leaf1', x: 42, y: 22 },
    { type: 'leaf2', x: 5, y: 15 },
    { type: 'leaf2', x: 29, y: 45 },
    { type: 'leaf2', x: 32, y: 47 },
    { type: 'leaf2', x: 39, y: 15 },
    { type: 'leaf3', x: 1, y: 29 },
    { type: 'leaf3', x: 3, y: 27 },
    { type: 'leaf3', x: 4, y: 22 },
    { type: 'leaf3', x: 7, y: 15 },
    { type: 'leaf3', x: 11, y: 31 },
    { type: 'leaf3', x: 20, y: 4 },
    { type: 'leaf3', x: 23, y: 0 },
    { type: 'leaf3', x: 27, y: 21 },
    { type: 'leaf3', x: 29, y: 24 },
    { type: 'leaf3', x: 34, y: 44 },
    { type: 'leaf3', x: 40, y: 36 },
    { type: 'leaf3', x: 43, y: 22 },
    { type: 'leaf3', x: 44, y: 29 },
    { type: 'leaf3', x: 44, y: 31 },
    { type: 'leaf3', x: 46, y: 21 },
    { type: 'leaf4', x: 3, y: 17 },
    { type: 'leaf4', x: 14, y: 6 },
    { type: 'leaf4', x: 17, y: 25 },
    { type: 'leaf4', x: 19, y: 48 },
    { type: 'leaf4', x: 21, y: 31 },
    { type: 'leaf4', x: 26, y: 44 },
    { type: 'leaf4', x: 29, y: 16 },
    { type: 'leaf4', x: 31, y: 46 },
    { type: 'leaf4', x: 36, y: 28 },
    { type: 'leaf4', x: 42, y: 12 },
    { type: 'leaf4', x: 42, y: 14 },
    { type: 'leaf4', x: 43, y: 14 },
    { type: 'stone1', x: 2, y: 3 },
    { type: 'stone1', x: 12, y: 32 },
    { type: 'stone1', x: 17, y: 41 },
    { type: 'stone1', x: 23, y: 21 },
    { type: 'stone1', x: 29, y: 35 },
    { type: 'stone1', x: 35, y: 48 },
    { type: 'stone1', x: 39, y: 34 },
    { type: 'stone1', x: 44, y: 1 },
    { type: 'stone1', x: 48, y: 40 },
    { type: 'stone2', x: 8, y: 3 },
    { type: 'stone2', x: 14, y: 12 },
    { type: 'stone2', x: 16, y: 44 },
    { type: 'stone2', x: 21, y: 5 },
    { type: 'stone2', x: 27, y: 13 },
    { type: 'stone2', x: 28, y: 35 },
    { type: 'stone2', x: 31, y: 46 },
    { type: 'stone2', x: 46, y: 35 },
    { type: 'stone3', x: 1, y: 38 },
    { type: 'stone3', x: 4, y: 9 },
    { type: 'stone3', x: 21, y: 3 },
    { type: 'stone3', x: 28, y: 22 },
    { type: 'stone3', x: 35, y: 38 },
    { type: 'stone3', x: 36, y: 42 },
    { type: 'stone3', x: 39, y: 20 },
    { type: 'stone3', x: 45, y: 10 },
    { type: 'stone3', x: 46, y: 17 },
    { type: 'stone3', x: 49, y: 25 },
    { type: 'stone4', x: 2, y: 14 },
    { type: 'stone4', x: 8, y: 18 },
    { type: 'stone4', x: 37, y: 38 },
    { type: 'stone4', x: 39, y: 11 },
    { type: 'web', size: 13, x: 44, y: 6, zIndex: 10 },

    // Water blockers
    { type: 'blocker', x: 0, y: 30 },
    { type: 'blocker', x: 0, y: 31 },
    { type: 'blocker', x: 0, y: 32 },
    { type: 'blocker', x: 0, y: 33 },
    { type: 'blocker', x: 0, y: 34 },
    { type: 'blocker', x: 1, y: 31 },
    { type: 'blocker', x: 1, y: 32 },

    { type: 'blocker', x: 3, y: 24 },
    { type: 'blocker', x: 3, y: 25 },
    { type: 'blocker', x: 4, y: 24 },
    { type: 'blocker', x: 4, y: 25 },

    { type: 'blocker', x: 4, y: 0 },
    { type: 'blocker', x: 4, y: 1 },
    { type: 'blocker', x: 4, y: 2 },
    { type: 'blocker', x: 5, y: 0 },
    { type: 'blocker', x: 5, y: 1 },
    { type: 'blocker', x: 5, y: 2 },
    
    { type: 'blocker', x: 6, y: 37 },
    { type: 'blocker', x: 6, y: 38 },
    { type: 'blocker', x: 7, y: 37 },
    { type: 'blocker', x: 7, y: 38 },

    { type: 'blocker', x: 14, y: 6 },
    { type: 'blocker', x: 14, y: 7 },
    { type: 'blocker', x: 15, y: 6 },
    { type: 'blocker', x: 15, y: 7 },

    { type: 'blocker', x: 16, y: 32 },
    { type: 'blocker', x: 17, y: 32 },
    { type: 'blocker', x: 18, y: 32 },

    { type: 'blocker', x: 27, y: 24 },

    { type: 'blocker', x: 28, y: 9 },
    { type: 'blocker', x: 28, y: 10 },
    { type: 'blocker', x: 29, y: 9 },
    { type: 'blocker', x: 29, y: 10 },

    { type: 'blocker', x: 35, y: 34 },

    { type: 'blocker', x: 36, y: 24 },
    { type: 'blocker', x: 37, y: 24 },
    { type: 'blocker', x: 38, y: 24 },

    { type: 'blocker', x: 40, y: 0 },
    { type: 'blocker', x: 41, y: 0 },
    { type: 'blocker', x: 42, y: 0 },

    { type: 'blocker', x: 42, y: 32 },
    { type: 'blocker', x: 43, y: 32 },

    { type: 'blocker', x: 43, y: 15 },
    { type: 'blocker', x: 44, y: 14 },
    { type: 'blocker', x: 44, y: 15 },

    // Bridge blockers
    { type: 'bridgeBlocker', x: 40, y: 42 },
    { type: 'bridgeBlocker', x: 40, y: 43 },
    { type: 'bridgeBlocker', x: 40, y: 44 },
    { type: 'bridgeBlocker', x: 40, y: 45 },
    { type: 'bridgeBlocker', x: 40, y: 46 },
    { type: 'bridgeBlocker', x: 41, y: 41 },
    { type: 'bridgeBlocker', x: 41, y: 42 },
    { type: 'bridgeBlocker', x: 41, y: 43 },
    { type: 'bridgeBlocker', x: 41, y: 44 },
    { type: 'bridgeBlocker', x: 41, y: 45 },

    // River blockers
    { type: 'blocker', x: 27, y: 49 },
    { type: 'blocker', x: 28, y: 49 },
    { type: 'blocker', x: 29, y: 48 },
    { type: 'blocker', x: 29, y: 49 },
    { type: 'blocker', x: 30, y: 48 },
    { type: 'blocker', x: 30, y: 49 },
    { type: 'blocker', x: 31, y: 47 },
    { type: 'blocker', x: 31, y: 48 },
    { type: 'blocker', x: 31, y: 49 },
    { type: 'blocker', x: 32, y: 46 },
    { type: 'blocker', x: 32, y: 47 },
    { type: 'blocker', x: 32, y: 48 },
    { type: 'blocker', x: 32, y: 49 },
    { type: 'blocker', x: 33, y: 46 },
    { type: 'blocker', x: 33, y: 47 },
    { type: 'blocker', x: 33, y: 48 },
    { type: 'blocker', x: 33, y: 49 },
    { type: 'blocker', x: 34, y: 45 },
    { type: 'blocker', x: 34, y: 46 },
    { type: 'blocker', x: 34, y: 47 },
    { type: 'blocker', x: 34, y: 48 },
    { type: 'blocker', x: 34, y: 49 },
    { type: 'blocker', x: 35, y: 45 },
    { type: 'blocker', x: 35, y: 46 },
    { type: 'blocker', x: 35, y: 47 },
    { type: 'blocker', x: 35, y: 48 },
    { type: 'blocker', x: 36, y: 44 },
    { type: 'blocker', x: 36, y: 45 },
    { type: 'blocker', x: 36, y: 46 },
    { type: 'blocker', x: 36, y: 47 },
    { type: 'blocker', x: 36, y: 48 },
    { type: 'blocker', x: 37, y: 44 },
    { type: 'blocker', x: 37, y: 45 },
    { type: 'blocker', x: 37, y: 46 },
    { type: 'blocker', x: 37, y: 47 },
    { type: 'blocker', x: 38, y: 43 },
    { type: 'blocker', x: 38, y: 44 },
    { type: 'blocker', x: 38, y: 45 },
    { type: 'blocker', x: 38, y: 46 },
    { type: 'blocker', x: 38, y: 47 },
    { type: 'blocker', x: 39, y: 43 },
    { type: 'blocker', x: 39, y: 44 },
    { type: 'blocker', x: 39, y: 45 },
    { type: 'blocker', x: 39, y: 46 },
    { type: 'blocker', x: 42, y: 41 },
    { type: 'blocker', x: 42, y: 42 },
    { type: 'blocker', x: 42, y: 43 },
    { type: 'blocker', x: 42, y: 44 },
    { type: 'blocker', x: 43, y: 40 },
    { type: 'blocker', x: 43, y: 41 },
    { type: 'blocker', x: 43, y: 42 },
    { type: 'blocker', x: 43, y: 43 },
    { type: 'blocker', x: 43, y: 44 },
    { type: 'blocker', x: 44, y: 39 },
    { type: 'blocker', x: 44, y: 40 },
    { type: 'blocker', x: 44, y: 41 },
    { type: 'blocker', x: 44, y: 42 },
    { type: 'blocker', x: 44, y: 43 },
    { type: 'blocker', x: 45, y: 39 },
    { type: 'blocker', x: 45, y: 40 },
    { type: 'blocker', x: 45, y: 41 },
    { type: 'blocker', x: 45, y: 42 },
    { type: 'blocker', x: 45, y: 43 },
    { type: 'blocker', x: 46, y: 38 },
    { type: 'blocker', x: 46, y: 39 },
    { type: 'blocker', x: 46, y: 40 },
    { type: 'blocker', x: 46, y: 41 },
    { type: 'blocker', x: 46, y: 42 },
    { type: 'blocker', x: 47, y: 38 },
    { type: 'blocker', x: 47, y: 39 },
    { type: 'blocker', x: 47, y: 40 },
    { type: 'blocker', x: 47, y: 41 },
    { type: 'blocker', x: 48, y: 37 },
    { type: 'blocker', x: 48, y: 38 },
    { type: 'blocker', x: 48, y: 39 },
    { type: 'blocker', x: 48, y: 40 },
    { type: 'blocker', x: 48, y: 41 },
    { type: 'blocker', x: 49, y: 37 },
    { type: 'blocker', x: 49, y: 38 },
    { type: 'blocker', x: 49, y: 39 },
    { type: 'blocker', x: 49, y: 40 },
];
